var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-table", {
        attrs: {
          hover: _vm.hover,
          striped: _vm.striped,
          bordered: _vm.bordered,
          small: _vm.small,
          fixed: _vm.fixed,
          responsive: "sm",
          items: _vm.items,
          fields: _vm.fields,
          "current-page": _vm.currentPage,
          "per-page": _vm.perPage
        },
        scopedSlots: _vm._u([
          {
            key: "status",
            fn: function(data) {
              return [
                _c(
                  "b-badge",
                  { attrs: { variant: _vm.getBadge(data.item.status) } },
                  [_vm._v(_vm._s(data.item.status))]
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "nav",
        [
          _c("b-pagination", {
            attrs: {
              "total-rows": _vm.getRowCount(_vm.items),
              "per-page": _vm.perPage,
              "prev-text": "Prev",
              "next-text": "Next",
              "hide-goto-end-buttons": ""
            },
            model: {
              value: _vm.currentPage,
              callback: function($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ab57a9e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ab57a9e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/tables/Table.vue
// module id = 1523
// module chunks = 0